<template>
  <div class="plan-dialog">
    <Dialog :open="open" size="fit-content" @close="$emit('close')">
      <div class="dialog-header">
        <div v-if="type === PlanDialogType.TRIAL_OFFER" class="dialog-header-icon-wrapper">
          <svg
            width="32" height="33" viewBox="0 0 32 33"
            fill="none" xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M29.3334 10.2582H27.8587C27.9591 9.82104 28.0066 9.37337 28 8.92487C28.0567 8.21008 27.9576 7.49153 27.7096 6.81876C27.4616 6.14599 27.0706 5.53503 26.5636 5.02802C26.0565 4.52101 25.4456 4.13002 24.7728 3.88202C24.1 3.63402 23.3815 3.53491 22.6667 3.59153C19.7814 3.59153 17.3747 6.61953 16 8.82887C14.6254 6.61953 12.2187 3.59153 9.33337 3.59153C8.61859 3.53491 7.90003 3.63402 7.22727 3.88202C6.5545 4.13002 5.94354 4.52101 5.43653 5.02802C4.92952 5.53503 4.53853 6.14599 4.29052 6.81876C4.04252 7.49153 3.94342 8.21008 4.00004 8.92487C3.99348 9.37337 4.04093 9.82104 4.14137 10.2582H2.66671C2.31309 10.2582 1.97395 10.3987 1.7239 10.6487C1.47385 10.8988 1.33337 11.2379 1.33337 11.5915V18.2582C1.33337 18.6118 1.47385 18.951 1.7239 19.201C1.97395 19.4511 2.31309 19.5915 2.66671 19.5915H4.00004V28.9249C4.00004 29.2785 4.14052 29.6176 4.39056 29.8677C4.64061 30.1177 4.97975 30.2582 5.33337 30.2582H26.6667C27.0203 30.2582 27.3595 30.1177 27.6095 29.8677C27.8596 29.6176 28 29.2785 28 28.9249V19.5915H29.3334C29.687 19.5915 30.0261 19.4511 30.2762 19.201C30.5262 18.951 30.6667 18.6118 30.6667 18.2582V11.5915C30.6667 11.2379 30.5262 10.8988 30.2762 10.6487C30.0261 10.3987 29.687 10.2582 29.3334 10.2582ZM9.33337 6.2582C10.8174 6.2582 12.5587 8.36887 13.744 10.2582H10.0747C6.66671 10.2582 6.66671 9.72487 6.66671 8.92487C6.66671 6.53553 8.18937 6.2582 9.33337 6.2582ZM14.6667 27.5915H6.66671V19.5915H14.6667V27.5915ZM14.6667 16.9249H4.00004V12.9249H14.6667V16.9249ZM22.6667 6.2582C23.8107 6.2582 25.3334 6.53553 25.3334 8.92487C25.3334 9.72487 25.3334 10.2582 21.9254 10.2582H18.256C19.4414 8.36887 21.1827 6.2582 22.6667 6.2582ZM25.3334 27.5915H17.3334V19.5915H25.3334V27.5915ZM28 16.9249H17.3334V12.9249H28V16.9249Z" fill="#058048" />
          </svg>
        </div>
        <h4 class="dialog-header-title">
          {{ title }}
        </h4>
      </div>
      <div class="dialog-content">
        <plans
          v-if="plans.length && type !== PlanDialogType.TRIAL_OFFER"
          :plans="plans"
          :disabled="loading"
          :loading="loading"
          @setSubscription="setSelectedPlan"
        />

        <loading :loading="loading" />
        <plan-price-card
          v-if="!loading && plan && type === PlanDialogType.TRIAL_OFFER" 
          :offer="offer"
          :plan="plan"
          :on-submit="() => {}"
          :set-selected-plan="setSelectedPlan"
        />
      </div>
      <div v-if="type === PlanDialogType.TRIAL_OFFER" class="dialog-footer">
        <a class="dialog-footer-action" href="#" @click.prevent="$emit('togglePlan')">
          Conheça outros planos
        </a>
      </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from '@/components/base/dialog'
import Loading from '@/components/base/Loading'
import Plans from '@/components/pages/payment/plans'
import PlanPriceCard from '@/components/pages/payment/plan-price-card'

export const PlanDialogType = {
  ALL_PLANS: 'all-plans',
  TRIAL_OFFER: 'trial-offer',
  TRIAL_OVER: 'trial-over'
}

export default {
  name: 'PlanDialog',
  components: { Dialog, Loading, Plans, PlanPriceCard },
  props: {
    offer: { type: Object, required: false, default: () => ({}) },
    open: { type: Boolean, required: false, default: false },
    plans: { type: Object, required: true },
    type: { type: String, default: PlanDialogType.TRIAL_OFFER },
    loading: { type: Boolean, required: false, default: false }
  },
  data: () => ({
    PlanDialogType
  }),
  computed: {
    plan() {
      if (!this.plans?.length) return undefined

      return this.plans.find(plan => plan.id === this.offer.preferred_plan_id)
    },
    title() {
      if (this.type === PlanDialogType.ALL_PLANS) {
        return 'Conheça nossos planos'
      }
      if (this.type === PlanDialogType.TRIAL_OFFER) {
        return 'Aproveite a oferta válida em período de teste!'
      }
      if (this.type === PlanDialogType.TRIAL_OVER) {
        return 'Seu teste grátis acabou!'
      }

      return ''
    }
  },
  methods: {
    setSelectedPlan(plan) {
      this.$emit('onSelectPlan', plan?.identifier)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/scss/variables';

.dialog-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  zoom: 0.9;

  .dialog-header-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80px;
    width: 80px;
    border-radius: 50%;
    background-color: $green100;
  }

  .dialog-header-title {
    @include LabelMedium;
    font-family: $monserratFontFamily;
    font-weight: 700;
    text-align: center;
    color: $neutral500;
  }
}

.dialog-content {
  zoom: 0.9;
}

.dialog-footer {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  margin-top: 24px;

  .dialog-footer-action {
    @include LabelSmall;
    font-weight: 700;
    text-decoration: none;
    color: $blue200;
  }
}
</style>
